<template>
    <div id="shareVehicleWrapper">
        <div id="shareVehicleFormOverlay">
        </div>
        
        <div id="moalSendMessageDiv">
            <div id="closeMessageFormDiv" @click="closeMessagePicturesForm">
                X
            </div>

            <div id="modal-header">
                Share This {{ vehicle.Year }} {{ vehicle.Make }} {{ vehicle.Model }}
            </div>
            
            <div id="modal-body">
                <div id="pictureSelectionDiv">
                    <div id="pictureSelectionTitle" :class="[!validation.picture ? 'is-danger' : ''] ">
                        <span>
                            Pictures to send:
                        </span>
                        <span v-if="!validation.picture" class="is-danger">
                            *Must select at least one picture 
                        </span>
                    </div>
                    <div class="image_scroller">
                        <div id="primaryImage" class="gallery_select" @click="toggleSelectedImage(primaryImage)" :class="[ selected_gallery.includes(primaryImage) ? 'selectedImage' : '']"><!--", unselectable(primaryImage) ? 'unselectable' : '']">-->
                            <img class="gallery_thumb" :src="primaryImage"/>
                        </div>
                        <div v-for="(car_image, index) in galleryImages" :key="index" class="gallery_select" @click="toggleSelectedImage(car_image.URL)" :class="[ selected_gallery.includes(car_image.URL) ? 'selectedImage' : '']"> <!--", unselectable(car_image.URL) ? 'unselectable' : '']">-->
                            <img class="gallery_thumb" :src="car_image.URL"/>
                        </div>
                    </div>
                </div>

                <div id="messageInfoInputDiv">
                    <div id="messageInfoDiv">
                        <div id="productSpecialistDiv" class="sendFormInputDiv">
                            <div id="prodSpecLabel" class="labelDiv" :class="[!validation.psId ? 'is-danger' : '']">
                                Online Specialist:
                            </div>
                            <div class="sendFormInput">
                            <select id="psSelectList" :class="[!validation.psId ? 'is-danger' : '']" v-model="productSpecialistId">
                                <option v-for="(ps, index) in productSpecialists" :key="index" :value="ps.repId">
                                    {{ ps.repName }}
                                </option>
                            </select>
                            </div>
                            <span v-show="!validation.psId" class="is-danger">
                                *Required
                            </span>
                        </div>

                        <div id="messageSubjectDiv" class="sendFormInputDiv">
                            <div id="messageSubjectLabel" class="labelDiv">
                                Subject:
                            </div>
                            <input type="text"  v-model="emailSubject" class="sendFormInput"/>
                        </div>

                        <div id="messageDiv" class="sendFormInputDiv">
                            <div id="messageLabelDiv" class="labelDiv">
                                Message:
                            </div>
                            <textarea rows="4" v-model="message" class="sendFormInput"></textarea>
                        </div>

                        <div id="guestNameDiv" class="sendFormInputDiv">
                            <div id="guestNameLabel" class="labelDiv" :class="[!validation.textguest ? 'is-danger' : '']">
                                Guest Name:
                            </div>
                            <input :class="[!validation.textguest ? 'is-danger': '']" type="text" v-model="guestName" class="sendFormInput"/>
                            <span v-show="!validation.textguest" class="is-danger">
                                *Required
                            </span>
                        </div>

                        <div id="emailDiv" class="sendFormInputDiv">
                            <div id="emailLabel" class="labelDiv" :class="[!validation.email ? 'is-danger' : '']">
                                Guest Email: 
                            </div>
                            <input :class="[!validation.email ? 'is-danger' : '']" type="text" v-model="guestEmail" class="sendFormInput"/>
                            <span  v-show="!validation.email" class="is-danger">
                                *Invalid email
                            </span>
                        </div>

                        <div id="phoneDiv" class="sendFormInputDiv" :class="[!validation.guestphone ? 'is-danger' : '']">
                            <div id="phoneLabel" class="labelDiv">
                                Guest Phone:
                            </div>
                            <input type="text" :class="[!validation.guestphone ? 'is-danger' : '']" v-model="guestNumber" class="sendFormInput"/>
                            <span v-show="!validation.guestphone" class="is-danger">
                                *10 digits required
                            </span>
                        </div>
                    </div>
                    <div id="messageButtons">
                        <div id="text_button" class="emailSmsFormButtons" @click="send_text">
                            Text
                            <div id="message_sending_wrapper"  :class="[textSubmitted ? 'appear' : '']" v-show="textSubmitted"></div>
                            <div id="message_sending" :class="[textSubmitted ? 'appear' : '']"></div>
                        </div>
                        <div id="email_button" class="emailSmsFormButtons" @click="send_email">
                            Email
                            <div id="message_sending_wrapper"  :class="[emailSubmitted ? 'appear' : '']" v-show="emailSubmitted"></div>
                            <div id="message_sending" :class="[emailSubmitted ? 'appear' : '']"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //validation rules RegExs
    var emailRE = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    var phoneRE = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/

    import config from '../config'

    export default {
        data() {
            return {
                productSpecialistId: "",
                guestName: "",
                guestNumber: "",
                message: "",
                guestEmail: "",
                emailSubject: "",
                textSubmitted: false,
                emailSubmitted: false,
                selected_gallery: [],
                validation: {
                    textguest: true,
                    guestphone: true,
                    picture: true,
                    psId: true,
                    email: true
                }
            }
        },
        mounted() {
            if(this.galleryImages.length == 0) {
                this.selected_gallery.push(this.primaryImage);
            }
        },
        computed: {
            vehicle() {
                return this.$store.getters.vehicleGallerySelected;
            },
            galleryImages() {
                return this.$store.getters.getOpenGalleryImages;
            },
            isBlueBlanket() {
                return (this.vehicle.cached_thumbnail && this.vehicle.cached_thumbnail.includes('BlueBlanket'));
            },
            primaryImage() {
                return this.isBlueBlanket ? this.vehicle.cached_thumbnail.replace("_400h", "") : ((this.vehicle.cached_primary_image) ? this.vehicle.cached_primary_image : (this.vehicle.PrimaryImage ? this.vehicle.PrimaryImage : "/pictures_coming_soon.png"));
            },
            productSpecialists() {
                return this.$store.getters.getProductSpecialistsList;
            }
        },
        methods: {
            isValid() {//loop through all the validations if any fail then return false
                let valid = true;
                let validCount = 0;
                let validationTest = {
                    textguest: this.guestName.trim(),
                    guestphone:this.textSubmitted ? phoneRE.test(this.guestNumber) : true,
                    picture: (this.selected_gallery.length > 0),
                    psId: this.productSpecialistId > 0,
                    email: this.emailSubmitted ? emailRE.test(this.guestEmail) : true
                }

                this.validation = validationTest;

                while(valid && validCount < Object.keys(validationTest).length) {
                    valid = validationTest[Object.keys(validationTest)[validCount]];
                    validCount++;
                }

                return valid;
            },
            toggleSelectedImage(img) {
                if(this.selected_gallery.includes(img)) {
                    let imgIndex = this.selected_gallery.indexOf(img);
                    this.selected_gallery.splice(imgIndex, 1);
                }
                else { 
                    this.selected_gallery.push(img);
                }
            },
            send_email() {
                this.emailSubmitted = true;
                
                if(this.isValid()) {
                    this.submit_email();
                }
                else {
                    this.emailSubmitted = false;
                }
            },
            async submit_email() {
                this.$gtag.event('send_email', {'event_category': 'send_pictures'});
                
                let data = {
                        "emailTo": this.guestEmail,
                        "emailSubject": this.emailSubject,
                        "emailBody": this.message,
                        "emailProductSpecialistId": this.productSpecialistId,
                        "images": JSON.stringify(this.selected_gallery),
                        "sms_vin": this.vehicle.VIN
                };

                let options = this.$store.getters.isLoggedIn ? {headers: {Authorization: 'Bearer ' + this.$store.getters.getAuthUser.token}} : {};

                try {
                    let response = await config.clientAdminApi.post('v2/wholesaleemail', data, options)
                    let json = response.data;

                    this.$store.commit('setMessageToGuest', json.message);
                }
                catch(e) {
                    this.$store.commit('setMessageToGuest', "Your email failed to send. Please check verify your input and try again. If this persists please contact us.");
                }
                finally {
                    this.emailSubmitted = false;
                }
            },
            send_text() {
                this.textSubmitted = true;

                if(this.isValid()) {
                    this.submit_message();
                }
                else {
                    this.textSubmitted = false;
                }
            },
            async submit_message() {
                this.$gtag.event('send_text', {'event_category': 'send_pictures'});
                    
                let data = {
                        "smsTextTo": this.guestNumber,
                        "images": JSON.stringify(this.selected_gallery),
                        "smsTextMessage": this.message,
                        "smsGuestName": this.guestName,
                        "sms_vin": this.vehicle.VIN,
                        "productSpecialistId": this.productSpecialistId
                };

                let options = this.$store.getters.isLoggedIn ? {headers: {Authorization: 'Bearer ' + this.$store.getters.getAuthUser.token}} : {};

                try {
                    let response = await config.clientAdminApi.post('v2/wholesalemms', data, options);
                    let json = response.data;

                    this.$store.commit('setMessageToGuest', json.message);
                }
                catch(e) {
                    this.$store.commit('setMessageToGuest', "Your text message failed to send. Please check verify your input and try again. If this persists please contact us.");
                }
                finally {
                    this.textSubmitted = false;
                }
            },
            closeMessagePicturesForm() {
                this.$gtag.event('close', {'event_category': 'send_pictures'});
                this.$store.commit('setVehicleShareFormOpen', false)
            }
        }
    }
</script>

<style scoped>
    #shareVehicleFormOverlay {
        position: fixed;
        z-index: 3;
        background-color: black;
        opacity: .6;
        height: calc(100 * var(--vh));
        width: calc(100 * var(--vw));
        top: 0;
        left: 0;
    }

    input, select, textarea {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        font-size: calc((1 * var(--vw)) + ((var(--vratio) - .5) * 1em)); /*calc(.5vw + ((1 - var(--vratio)) * 1em));*/
    }

    .inmobile * input, select, textarea {
		font-size: calc(2.1 * var(--vh))
    }

    #moalSendMessageDiv {
		position: fixed;
        top: calc(20 * var(--vh));
        left: calc(10 * var(--vw));
        z-index: 4;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        width: calc(80 * var(--vw));
        height: calc(60 * var(--vh));
        background: linear-gradient(#DFDFDF, #FFFFFF);
        border-radius: calc(var(--vratio) * 3 * var(--vh));/*15px;*/
    }

    #closeMessageFormDiv {
        position: absolute;
        height: calc(4 * var(--vw));
        width: calc(4 * var(--vw));
        top: calc(2 * var(--vw));
        right: calc(2 * var(--vw));
        font-size: calc(1.8 * var(--vw));
        color: black;
        font-weight: bolger;
        cursor: pointer;
    }

    #closeMessageFormDiv:hover {
        color: var(--mccluskeyGold); /*#AF873F;*/
    }
    
    #modal-header {
        text-align: center;
        width: 100%;
        height: calc(8 * var(--vh));
        margin: calc(1 * var(--vh)) 0;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: calc(2.2 * var(--vw));
	}

    #modal-body {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        width: calc(78 * var(--vw));
        height: calc(46 * var(--vh));
        margin: calc(1 * var(--vh)) calc(1 * var(--vw));
    }

    #pictureSelectionDiv {
        width: calc(((41.75 / 3) * 5 * var(--vh))); /*calc(52 * var(--vw));*/
        height: calc(46 * var(--vh));
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
    }

    #pictureSelectionTitle {
        height: calc(2 * var(--vh));
        width: 100%;
        margin: calc(1 * var(--vh)) 0;
        font-size: calc(1.5 * var(--vw));
    }
    
    .image_scroller {
        overflow-y: scroll;
        display: flex;
        flex-wrap: wrap;
        height: calc(41.75 * var(--vh));
        width: calc(100% - (.25 * var(--vh)));
        margin: calc(.875 * var(--vh)) calc(.875 * var(--vh));
    }
    
    .gallery_select {
        display: inline-block;
        width: calc(((40.75 / 3) - .875) * var(--vh));
        margin: calc(.125 * var(--vh));
        height: calc(((40.75 / 4) - .875) * var(--vh));
        border: solid #DFDFDF calc(.375 * var(--vh));
        border-radius: calc(var(--vratio) * var(--vh));/*5px;*/
    }
    
    .gallery_thumb {
        width: calc(((40.75 / 3) - .875) * var(--vh));
        height: calc(((40.75 / 4) - .875) * var(--vh));
        object-fit: cover;
    }

    .selectedImage {
        border-color: var(--mccluskeyGold); /*#AF873F;*/
    }

    #messageInfoInputDiv {
        width: calc((75 * var(--vw)) - ((41.75 / 3) * 5 * var(--vh)));
        height: calc(46 * var(--vh));
    }

    #messageInfoDiv {
        width: 100%;
        margin: calc(4 * var(--vh)) 0 calc(1 * var(--vw));
    }

    .sendFormInputDiv {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .sendFormInput {
        width: 50%;
        margin: calc(.25 * var(--vh)) calc(1 * var(--vw));
    }

    #psSelectList {
        min-width: 100%;
        width: 100%;
    }
        
    textarea {
        border: 1px solid gray;
        border-radius: calc(var(--vratio) * var(--vh));/*3px;*/
        padding: 2px;
        background-color: white;
        width:100%;
    }

    #messageButtons {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .emailSmsFormButtons {
		cursor: pointer;
        width: calc(5 * var(--vw));
        height: calc(3 * var(--vh));
        color: white;
        font-weight: bold;
        background-color: var(--mccluskeyBlue); /*#0077C0;*//*#0079B6;*/
        border-radius: calc(var(--vratio) * var(--vh));/*5px;*/
        border: solid white .75px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: calc(1 * var(--vh)) calc(1 * var(--vw));
        position: relative;
    }

    .emailSmsFormButtons:hover {
        color: black;/*#2B2A2B;*/
        border-color: var(--mccluskeyGold); /*#AF873F;*/
    }

    .is-danger {
        color: red;
        font-style: italic;
        font-weight: thin;
        border-color: red;
    }

    span.is-danger {
        font-size: .6em;
    }

    #message_sending_wrapper {
        position: absolute;
        height: inherit;
        width: inherit;
        background-color: black;
        z-index: 40;
        opacity: 0;
        transition: opacity 1s;
    }

    #message_sending_wrapper.appear {
        opacity: .4;
    }

    #message_sending {
        position: absolute;
        left: calc(2.5 * var(--vw));
        top: calc(1.5 * var(--vh));
        z-index: 42;
        margin: -15px 0 0 -15px;
        border: 6px solid rgb(172,179,183);
        border-radius: calc(var(--vratio) * var(--vh));
        border-top: 6px solid var(--mccluskeyBlue); /*#207BD3;*/
        width: 18px;
        height: 18px;
        -webkit-animation: spin 3s linear infinite;
        animation: spin 3s linear infinite;
        opacity: 0;
        -webkit-transition: opacity 1s;
        -moz-transition: opacity 1s;     
        transition: opacity 1s;
    }

    #message_sending.appear {
        opacity: 1;
    }
    
    @-webkit-keyframes spin {
        0% { -webkit-transform: rotate(0deg); }
        100% { -webkit-transform: rotate(360deg); }
    }
    
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
    /*.crash {
			vertical-align: middle;
			position: absolute;
			right: 5px;
			top: 5px;
			display: inline-block;
			font-size: 10px;
			background: url(/images/mini_x_button_red.png) no-repeat top right;
			min-width: 10px;
			height: 10px;
			color: gray;
		}
		.crash:hover {
			background-position: bottom right;
			color: red;
		}*/
</style>
